<div class="day-break-parent">
  <div class="full-width-border"></div>
  <div class="day-break-container">
    <div class="mt-3 mb-3">
      <strong>Day {{ currentDayNumber }} of {{ totalDays }}</strong
      >:
      {{ dayDate | date : 'EEE, d MMM yyyy' : '' : 'en-GB' }}
    </div>
    <div *ngIf="isCarryoverDay" class="mt-3 mb-3">
      <span class="tag carryover">
        <img src="assets/images/icons/svg/carryover_moon-filled.svg" alt="icon" class="icon" />
        Carryover
      </span>
    </div>
  </div>
  <div class="full-width-border"></div>
</div>
